/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as React from 'react';
import cx from 'classnames';

import styles from './ExternalPageFrame.module.scss';

/**
 * Layout shell for external apps: a full-viewport flex column that keeps
 * chrome (nav/footer) pinned and lets SkipNavContent grow to fill the middle.
 * Structure only — pair with ExternalAppProviders for app behavior.
 *
 * `SkipNavContent` is a required child; the frame styles target
 * `[data-component="SkipNavContent"]` for the flex-grow middle region.
 */
export function ExternalPageFrame({
    children,
    className,
    ...rest
}: React.HTMLAttributes<HTMLDivElement>) {
    return (
        <div className={cx(styles.frame, className)} {...rest}>
            {children}
        </div>
    );
}
